<template>
  <section id="workPlaceSelection" class="workPlaceSelection">
       <div class="">
      <div class="card-alt-body">
    <div class="page-header">
      <div class="row justify-content-end">
        <div class="col">
          <h2 class="page-title mb-2">{{$t('workPlace.lblWorkPlace')}}</h2>
        </div>
      </div>
    </div>
    
      <div class="row mt-3">
        <div class="col-md-12">
          <div class="alert alert-success"><small> {{$t('workPlace.infoStatment1')}} <b>{{courseUniObj.courseName}}</b> {{$t('workPlace.infoStatment2')}} <b>{{courseUniObj.uniName}}</b>. </small></div>
          <div class="download-card">
            <div class="download-card-header">
              <div class="row mb-2">
                <div class="col-lg-6">
                  <h3 class="instruction-title">{{$t('workPlace.lblInstruction')}}</h3>
                </div>
                <!-- <div class="col-lg-2 col-sm-4 text-center">
                  <a type="button" class="btn btn-xs btn-default btn-circle" :href="instructions.pdfURL" download target="_blank">
                    <i class="mdi mdi-file"></i>
                  </a>
                  <p class="btn-text">Download pdf</p>
                </div> -->
                <div class="col-lg-2 col-sm-4 text-center" v-if="instructions.pdfURL">
                  <a  class="btn btn-xs btn-default btn-circle" :href="instructions.pdfURL" download target="_blank">
                    <i class="mdi mdi-file"></i>
                  </a>
                  <p class="btn-text">Download pdf</p>
                </div>
                <div class="col-lg-2 col-sm-4 text-center" v-if="instructions.audioURL">
                  <button type="button" class="btn btn-xs btn-default btn-circle" @click="playInstructionAudio">
                    <i class="mdi mdi-headphones-settings"></i>
                  </button>
                  <p class="btn-text">Play Audio</p>
                </div>
                <div class="col-lg-2 col-sm-4 text-center" v-if="instructions.videoURL">
                  <button type="button" class="btn btn-xs btn-default btn-circle" @click="playInstructionVideo">
                    <i class="mdi mdi-video"></i>
                  </button>
                  <p class="btn-text">Play Video</p>
                </div>
              </div>
            </div>
            <div>
                <!-- Modal for audio -->
                <b-modal size="md" ref="instrAudioModalRef" hide-footer @hidden="hideAudioModal" :title="$t('workPlace.lblInstruction')">
                  <div class="d-block text-left">
                    <audio ref="audioRef" src="" id="audio-container" type="audio/mpeg" width="100%" controls></audio>
                  </div>
                </b-modal>
                <!-- Modal for audio -->
                <b-modal size="lg" ref="instrVideoModalRef" hide-footer @hidden="hideInstructionVideoModal" :title="$t('workPlace.lblInstruction')">
                  <div class="d-block text-left">
                    <div id="app">
                      <iframe ref="instrVideoRef" src="" id="video-container" width="100%" height="450"></iframe>
                    </div>
                  </div>
                </b-modal>
            </div>
            <div class="download-card-body">
              <div class="text-content ">
                 
              <ul class="instructions height">
              <li v-for="item in instructions.instructionList">{{item.instructionMsg}}
                <ul class="subInstructionFont" v-if="item.subInstructions">
              <li v-for="subItem in item.subInstructions">{{subItem.instructionMsg}} </li>
                </ul>

              </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    <div class="row">
      <div class="col-12">
        <div class="row wrap">
          <div class="col">
            <div class="panel"> 
              <div class="panel__heading mt-3 mb-3 pr-3">
                <div class="input-group" >
                <span class="input-group-addon" id="search"><i class="mdi mdi-magnify"></i></span>
                <input type="text" class="form-control" v-model="searchBox" :placeholder="$t('workPlace.plceHoWorkPlace')" aria-describedby="Select places for workplace">
                </div>
              </div>            
              <div v-bar>
                <div>
                  <div class="list-wrap">
                    <transition-group name="sleek" class="pr-3" tag="div"> 
                    <div class="list-css" v-for="item in orderBy(filterWorkPlaceList, 'districtName')" :key="item.districtID">
                      <div class="row justify-content-end">
                        <div class="col text-left align-self-center"> {{item.districtName}}</div>
                        <div class="col-auto text-right">
                        <div class="btn btn-info-alt btn-sm text-right" v-on:click="copyWorkPlace(item)">{{$t('button.select')}}</div>
                        </div>
                      </div>
                    </div>
                    </transition-group>
                    <div v-if="filterWorkPlaceList.length < 1" class="red">
                      {{$t('workPlace.erorNotMatchFound')}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col pl-2">
            <div class="panel selectedItem">
              <div class="panel__heading">
                <h4 class="pt-4 mb-4">{{$t('workPlace.lblSelectedWorkPlace')}}</h4>
              </div>
              <div v-if="selectedWorkPlaceList.length < 1" class="grey panel__heading">
                <h5 class="bigtext text-center">{{$t('workPlace.erorNotSelected')}}</h5>
              </div>
              <div class="right-list-wraper" v-if="selectedWorkPlaceList.length > 0">
              <div v-bar >
                <div> 
                  <div class="list-wrap">
                    <transition-group name="slide" class="pr-3" tag="div"> 
                    <div class="list-checked" v-for="(item, index) in selectedWorkPlaceList" :key="item.districtID">
                      <div class="row justify-content-end">
                        <div class="col-8 text-left"><b> {{item.sequence}}.&nbsp; </b>   {{item.districtName}}     <i class="mdi mdi-checkbox-marked-circle"></i>    </div>
                        <div class="col-4">
                          <div class="row justify-content-end">
                          <div class="col-4">
                          <i title="Move Up" v-if="index != 0" class="mdi mdi-chevron-up" v-on:click="upSequence(item)"></i>
                          </div>
                          <div class="col-4">
                          <i title="Move Down" v-if="index != selectedWorkPlaceList.length - 1" class="mdi mdi-chevron-down" v-on:click="downSequence(item)"></i>
                          </div>
                          <div class="col-4">
                          <i class="mdi mdi-delete btn btn-sm" title="Delete" v-on:click="removeWorkPlace(item)"></i>
                          </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    </transition-group>
                  </div>
                </div>
              </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-center mt-5">
      <div class="col-12 text-right">
          <button class="btn btn-orange" v-on:click="showConfirmation = true">{{$t('button.save')}}</button>
      </div>
    </div>
    </div>
    <modal class="sm" v-if="showConfirmation" @close="showConfirmation = false">   
          <h3 slot="header">Please verify order of your Work Place preference form before you save.</h3>
          <div slot="body">
            <div class="row justify-content-center">
            <button type="button" class="btn btn btn-success-alt mr-3" @click="save()"> {{$t('button.confirm')}}</button>             
            <button type="button" class="btn btn btn-danger-alt mr-3" @click="showConfirmation = false"> {{$t('button.cancel')}}</button>             
                </div>
           </div>
           <div slot="footer">
           </div>
    </modal>
    </div>
  </section>
</template>

<script>
import axios from 'axios'
import modal from '@/components/common/modal.vue'
export default {
  name: 'workPlace',
  components: {modal},
  data () {
    return {
      searchBox: '',
      workPlaceList: [],
      selectedWorkPlaceList: [],
      courseUniObj: {},
      universityConfig: {},
      instructions: {},
      showConfirmation: false
    }
  },
  computed: {
    // Filter work place list for search box.
    filterWorkPlaceList: function () {
      var self = this
      return self.workPlaceList.filter(function (user) {
        var searchRegex = new RegExp(self.searchBox, 'i')
        return searchRegex.test(user.districtName)
      })
    }
  },
  methods: {
     // This method play audio.
    playInstructionAudio () {
      this.$refs.instrAudioModalRef.show()
      this.$refs.audioRef.src = this.instructions.audioURL
      this.$refs.audioRef.play()
    },
    // This method hide details audio.
    hideAudioModal () {
      this.$refs.instrAudioModalRef.hide()
      this.$refs.audioRef.pause()
    },
    // This method play audio.
    playInstructionVideo () {
      this.$refs.instrVideoModalRef.show()
      this.$refs.instrVideoRef.src = this.instructions.videoURL + '?autoplay=0'
    },
    // This method hide details audio.
    hideInstructionVideoModal () {
      this.$refs.instrVideoRef.src = this.instructions.videoURL + '?autoplay=0'
      this.$refs.instrVideoModalRef.hide()
    },
    getInstruction: function () {
      // This method get Industry partner instructions .
      axios
        .get('r/getGeneralInstructions/' + 'WorkPlacePage')
        .then(response => {
          if (response.status === 200) {
            this.instructions = response.data
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
     // Change the sequence of work place. (Decrease sequence)
    upSequence (item) {
      for (const k in this.selectedWorkPlaceList) {
        if (this.selectedWorkPlaceList[k].districtID === item.districtID) {
          var seq1 = this.selectedWorkPlaceList[k]
          seq1.sequence = item.sequence - 1
          var seq2 = this.selectedWorkPlaceList[parseInt(k) - 1]
          seq2.sequence = item.sequence + 1
          this.selectedWorkPlaceList.splice(parseInt(k) - 1, 2, seq1, seq2)
          break
        }
      }
    },
    // Change the sequence of work place. (Increase sequence)
    downSequence (item) {
      for (const k in this.selectedWorkPlaceList) {
        if (this.selectedWorkPlaceList[k].districtID === item.districtID) {
          var seq1 = this.selectedWorkPlaceList[k]
          seq1.sequence = item.sequence + 1
          var seq2 = this.selectedWorkPlaceList[parseInt(k) + 1]
          seq2.sequence = item.sequence - 1
          this.selectedWorkPlaceList.splice(k, 2, seq2, seq1)
          break
        }
      }
    },
    // Selecting the work place for application (Auto sequence).
    copyWorkPlace (item) {
      var dataFound = false
      for (const i in this.selectedWorkPlaceList) {
        if (item.districtID === this.selectedWorkPlaceList[i].districtID) {
          dataFound = true
          this.$toasted.info(this.$t('workPlace.toastrExistData'), {
            theme: 'bubble',
            duration: this.TOASTR_TIME
          })
          break
        }
      }
      if (dataFound === false) {
        item.sequence = this.selectedWorkPlaceList.length + 1
        this.selectedWorkPlaceList.push(item)
        this.$toasted.info(item.districtName + ' ' + this.$t('workPlace.toastrAddedInCart'), {
          theme: 'bubble',
          duration: this.TOASTR_TIME
        })
      }
      for (const j in this.workPlaceList) {
        if (item.districtID === this.workPlaceList[j].districtID) {
          this.workPlaceList.splice(j, 1)
          break
        }
      }
    },
    // Remove the selected work place from list. (Delete)
    removeWorkPlace (item) {
      this.workPlaceList.push(item)
      for (const j in this.selectedWorkPlaceList) {
        if (item.districtID === this.selectedWorkPlaceList[j].districtID) {
          this.selectedWorkPlaceList.splice(j, 1)
          for (const k in this.selectedWorkPlaceList) {
            if (this.selectedWorkPlaceList[k].sequence > item.sequence) {
              this.selectedWorkPlaceList[k].sequence --
            }
          }
          this.$toasted.info(item.districtName + ' ' + this.$t('workPlace.toastrDelete'), {
            theme: 'bubble',
            duration: this.TOASTR_TIME
          })
          break
        }
      }
    },
    getProjectConfig () {
      axios.get('o/projectConfig/getUniversityConfig').then(response => {
        this.universityConfig = response.data
        this.getAllData()
      }).catch(function (e) {
        console.error(e)
      })
    },
    getAllData: function () {
        // Get work place list.
      axios
        .get('r/workPlace/getWorkPlaceListRoute')
        .then(response => {
          this.workPlaceList = response.data
          var tempDistrictObj = {'districtID': 10001, 'sequence': 0, 'districtName': ' Any where in ' + this.universityConfig.state.stateName}
          this.workPlaceList.push(tempDistrictObj)
        })
        .catch(e => {
          console.log('error in get work place list')
          console.log(e)
        })
        // Get course and university details.
      axios
        .get('r/workPlace/getCourseUniversityByID/' + this.$route.params.courseID + '/' + this.$route.params.universityID)
        .then(response => {
          this.courseUniObj = response.data
        })
        .catch(e => {
          console.log('error in get work place list')
          console.log(e)
        })
    },
    save: function () {
      // This method validate workplace. (At least one workplace should be selected for procced)
      if (this.selectedWorkPlaceList.length < 1) {
        this.$toasted.info(this.$t('workPlace.toastrWarningForSelection'), {
          theme: 'bubble',
          duration: this.TOASTR_TIME
        })
        return false
      }
      // This method save workplace list in user application details in candidate_application collection(mongoDB).
      var userName = this.$store.state.candidateProfile.profileUser
      var courseID = this.$route.params.courseID
      var universityID = this.$route.params.universityID
      var allOverStateExist = false
      for (let index = 0; index < this.selectedWorkPlaceList.length; index++) {
        if (this.selectedWorkPlaceList[index].districtID === 10001) {
          allOverStateExist = true
        }
      }
      if (allOverStateExist === false) {
        var tempDistrictObj = {'districtID': 10001, 'sequence': this.selectedWorkPlaceList.length + 1, 'districtName': ' Any where in ' + this.universityConfig.state.stateName}
        this.selectedWorkPlaceList.push(tempDistrictObj)
      }
      axios
        .post('r/workPlace/saveWorkPlaceListRoute/' + userName + '/' + courseID + '/' + universityID, this.selectedWorkPlaceList)
        .then(response => {
          if (response.status === 200) {
            this.$toasted.success(this.$t('workPlace.toastrSaveData'))
            this.$store.commit('STORE_CONFIRM_STATUS', true)
            window.MKCLAPI.switchAppWithSingleSignOn(this.MFS_CLIENT_ID)
          }
        })
        .catch(e => {
          console.log('error in save methods')
          console.log(e)
        })
    }
  },
  created: function () {
    if (this.$route.params.courseID === undefined || this.$route.params.courseID === null || this.$route.params.courseID === '' || this.$route.params.universityID === undefined || this.$route.params.universityID === null || this.$route.params.universityID === '') {
      this.$router.push({ name: 'candidateApplication' })
    } else {
      this.getProjectConfig()
      this.getInstruction()
    }
  }
}
</script>

<style lang="scss">
.workPlaceSelection{  
.selectedItem{


  .mdi-delete{font-size:19px; color:#888; &:hover{color:#555;}}
  .mdi-checkbox-marked-circle{
    color:#8acc10;
     font-size:24px;
 vertical-align: middle;
 padding-left:10px;
  }
  .mdi-chevron-up{
    color:#72a711;
    padding-left:10px;
    padding-right:10px;
    cursor: pointer;
     font-size:24px;
 vertical-align: middle;
 padding-left:10px;
  }
  .mdi-chevron-down{
    color:#ff4949;
    padding-left:10px;
    padding-right:10px;
    cursor: pointer;
     font-size:24px;
 vertical-align: middle;
 padding-left:10px;
  }
  
}
    .vb > .vb-dragger {
    z-index: 5;
    width: 12px;
    right: 0;
}
.grey{color:#999;}
.bigtext{
  opacity:0.2;
  font-size:30px;
  font-weight:600;
  padding-top:20px;
  padding-left:0px;
}

// slide
 .card-alt {
    // margin:0px;
    padding: 40px;
    min-height: 600px;
    margin-bottom:80px;
    // box-shadow: none;
  }
  .card-alt-body {
    padding-top: 0px;
  }
  .card-alt-header {
    padding-left: 15px;
    padding-top: 40px;
    padding-bottom: 10px;
  }
  .slide-leave-to{
    transform: translateX(-100%);
    opacity:0.5;
  }
  .slide-enter{
    transform: translateX(-100%);
     opacity:0.5;
  }
  .slide-enter-to, .slide-leave{
    opacity:1;transform: translateY(50%); 
  }
  .slide-enter-active, .slide-leave-active{
    transition: all 200ms ease-in-out;
  }
  // sleek
  .sleek-leave-to{
    transform: translateX(100%);
    opacity:0.5;
    transform: translateY(20%);
  }
  .sleek-enter{
    transform: translateX(50%);
    transform: translateY(20%); 
     opacity:0.5;
  }
  .sleek-enter-to{
    opacity:1;
    
    //  transform: translateX(100%);
  }
  .sleek-leave{
    opacity:0.5;
    // transform: translateY(50%); 
    // transform: translateX(100%);
    
  }
  .sleek-enter-active, .sleek-leave-active{
    transition: all 100ms ease-in-out;
  }
.vb > .vb-dragger > .vb-dragger-styler {
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    -webkit-transform: rotate3d(0,0,0,0);
    transform: rotate3d(0,0,0,0);
    -webkit-transition:
        background-color 100ms ease-out,
        margin 100ms ease-out,
        height 100ms ease-out;
    transition:
        background-color 100ms ease-out,
        margin 100ms ease-out,
        height 100ms ease-out;
    background-color: rgba(194, 195, 197, 0.3);
    // margin: 5px 5px 5px 0;
    margin:0;
    border-radius: 20px;
    height: calc(100% - 10px);
    display: block;
}
.vb-dragger{background-color: rgba(194, 195, 197, 0); margin:0px;   height: 90%;}
.vb.vb-scrolling-phantom > .vb-dragger > .vb-dragger-styler {
    background-color: rgba(194, 195, 197, 0.3);
     height: 100%;
}

.vb > .vb-dragger:hover > .vb-dragger-styler {
    background-color: rgba(194, 195, 197, 0.3);
    margin: 0px;
    height: 100%;
}

.vb.vb-dragging > .vb-dragger > .vb-dragger-styler {
    background-color: rgba(194, 195, 197, 0.3);
    margin: 0px;
    height: 100%;
}

.vb.vb-dragging-phantom > .vb-dragger > .vb-dragger-styler {
    background-color: rgba(194, 195, 197, 0.3);
    margin:0px;
     height: 100%;
}

.panel__body{
padding-left:15px;
padding-right:15px;
}
.panel__heading{
  padding-bottom:10px;
  .input-group{    
    border: 1px solid #f2f2f2;
    box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.1);
    padding: 0;
   border-radius:5px;
    .input-group-addon{
       background: #fff;padding: 10px;line-height: 25px;   
      .mdi{font-size:20px; display: inline-block; margin-top:-9px; color:#6C757D;}
    }
    .form-control{
      background-color:transparent;
          
    font-family: inherit;
    font-weight: 500;
    background: #fff;
    color: inherit;
    box-shadow: none;
    border:none;
    }
  }
}

.list-wrap{
  height: 450px;
  scroll-behavior: auto;
}
.list-css{
  padding:7px 15px;
  background-color:#fff;
  margin-bottom:10px;
  transition: all 200ms ease-in-out;
  border-radius:3px;
  transition: 300ms ease;
  &:hover{
    box-shadow: 2px 2px 15px rgba(0, 0, 0, 0.1);
  }
  .col-auto{
    .btn{visibility: hidden; font-size:12px; padding:9px 26px; background-color:transparent; border:none;}
  }
  &:hover{
   .btn{visibility: visible; background-color:#8acc10;}
  }
}
.list-checked{
  padding:7px 15px;
  background-color:#ececec;
  margin-bottom:10px;
  transition: all 200ms ease-in-out;
  border-radius:3px; 

  &:hover{
       box-shadow: 2px 2px 15px rgba(0, 0, 0, 0.1);
  }
}
.list-checked1{
  padding:7px 15px;
  background-color:#fff;
  margin-bottom:10px;
  transition: all 200ms ease-in-out;
  border-radius:3px;
  transition: 300ms ease;
  &:hover{
    box-shadow: 2px 2px 15px rgba(0, 0, 0, 0.1);
  }
  .col-auto{
    .btn{visibility: hidden; font-size:12px; padding:9px 26px; background-color:transparent; border:none;}
  }
  &:hover{
   .btn{visibility: visible; background-color:#8acc10;}
  }
}
   .card-alt {
    // margin:0px;
    padding: 40px;
    min-height: 600px;
    margin-bottom:80px;
    // box-shadow: none;
  }
  .card-alt-body {
    padding-top: 0px;
  }
  .card-alt-header {
    padding-left: 15px;
    padding-top: 40px;
    padding-bottom: 10px;
  }
  .input-group{
    
    border: 1px solid #f2f2f2;
    box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.1);
    padding: 0;
   border-radius:5px;
    .input-group-addon{
       background: #fff;padding: 10px;line-height: 25px;   
      .mdi{font-size:20px; display: inline-block; margin-top:-9px; color:#6C757D;}
    }
    .form-control{
      background-color:transparent;
          
    font-family: inherit;
    font-weight: 500;
    background: #fff;
    color: inherit;
    box-shadow: none;
    border:none;
    }
  }
      .card-sec{
          
        margin-top:30px;
        margin-bottom:50px;
            .card-course{
              margin-bottom:40px;
                padding-top:30px;
                padding:20px;
                transition: all 0.3s cubic-bezier(.25,.8,.25,1);
                box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);  
                border-radius: 5px;
                border:1px solid #fff;
                background: #fff; 
                // transition: 300ms ease; transition: 300ms ease; position: relative;
                &:hover {
                    box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);
                    // .btn{background: lighten(#4885ed,22%); color:#4885ed; font-weight:600; letter-spacing: 0.2px;}
                }
                hr{border-color:transparent;}
                .ctitle{font-size:18px; font-weight: 400;}
                .utitle{font-size:14px;}
                .btn{
                    border:none; 
                    padding:8px 28px; 
                    // font-size:11px; 
                    margin-right:10px;
                    &:hover{box-shadow: none; }
                }
                .course-icon{
                      position: absolute;
                      bottom: 52px;
                      right: 34px;
                      font-size: 23px;
                      color: #f1f1f1;
                      z-index: 0
                }
                .card-data{
                  position: relative;
                  z-index: 101;
                }
            }
        }
        .help{font-size:11px; word-spacing: 1px; padding-left:12px;text-transform: uppercase; }
        .red{color:#ec4343; padding-left:15px;}
        .v-select {
            .dropdown-toggle {
            z-index: 3;
            
            border-left: 0px;
            border-right: 0px;
            border-top: 0px;
            padding-left: 0px;
            border-radius: 0px;
            font-family: 'Open Sans';
            font-weight: 600;
            border-color:#ddd;
            .clear {
                line-height: 20px;
            }
            }
            .dropdown-menu {
            z-index:3;
            // box-shadow: none;
            font-family: 'Open Sans';
            border-radius: 5px;
            font-size: 14px;
            border: none;
            box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.2);
            }
            .selected-tag {
            color: #495057;
            font-size: 18px;
            font-weight: 500;
            letter-spacing: 0.25px;
            }
        }
          .custom-input {
    z-index:2;
    input::placeholder {
      /* Chrome, Firefox, Opera, Safari 10.1+ */
      color: #37474f;
      opacity: 1; /* Firefox */
    }

    :-ms-input-placeholder {
      /* Internet Explorer 10-11 */
      color: #37474f;
    }

    ::-ms-input-placeholder {
      /* Microsoft Edge */
      color: #37474f;
    }
    // border:0px solid #ddd;
    padding: 15px;
    margin-bottom: 0;
    label {
      font-size: 11px;
      color: #37474f;
      text-transform: uppercase;
      margin-bottom: 0;
      padding-left: 10px;
    }
   
    }
}
.paraFont{
  font-size: 14px;
}
.subInstructionFont{
  font-size: 12px;
}
.height{
  line-height: 2.0;
  font-weight: 500;
}

.doc-upload{
  .title{
    // font-size:1px;
    margin-top:30px;
        font-weight: 500;
    // font-size: 18px;
    // color: #78838e;
    display: block;

  }
  .vue-dropzone{
    border:2px dashed #bbb;
    margin-top:10px;
    font-family: 'Open Sans';
    // font-size:13px;
    padding-top:25px;
    margin-bottom:0px;
    background-color:#f7f7f7;
    border-radius:5px;
    // padding-right:50px;
     .dz-preview .dz-details {
      bottom: 0;
      margin-right:30px;
      top: 0;
      color: #555;
      // background-color: #fff;
      background-color:#fff;
      transition: opacity .2s linear;
      text-align: left;
      border-radius:4px;
        
    }
    .dz-remove {
          position: absolute;
          z-index: 30;
          color: white;
          background-color: #aaa;
          margin-left: 15px;
          padding: 10px 20px;
          top: inherit;
          bottom: 15px;
          border-radius:20px;
          border: none;
          text-decoration: none;
          text-transform: uppercase;
          font-size: 12px;
          font-family: 'Open Sans';
          font-weight: 600;
          letter-spacing:0.4px;
          opacity: 0;
          &:hover{text-decoration: none; background-color:#999;}
      }
    &:hover{background-color:#eee;}
  }
}
.loader-wraper{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 101;
  background: rgba(255,255,255,0.7);
  animation: fadeIn  0.5s ease-in-out;
  .loader-box{
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  color:  #607D8B;

  }
  .lds-roller {
  display: block;
  position: relative;
  width: 64px;
  height: 64px;
  margin: 0 auto;
}
.lds-roller div {
  animation: lds-roller 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  transform-origin: 32px 32px;
}
.lds-roller div:after {
  content: " ";
  display: block;
  position: absolute;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #607D8B;
  margin: -3px 0 0 -3px;  
}
.lds-roller div:nth-child(1) {
  animation-delay: -0.036s;
}
.lds-roller div:nth-child(1):after {
  top: 50px;
  left: 50px;
}
.lds-roller div:nth-child(2) {
  animation-delay: -0.072s;
}
.lds-roller div:nth-child(2):after {
  top: 54px;
  left: 45px;
}
.lds-roller div:nth-child(3) {
  animation-delay: -0.108s;
}
.lds-roller div:nth-child(3):after {
  top: 57px;
  left: 39px;
}
.lds-roller div:nth-child(4) {
  animation-delay: -0.144s;
}
.lds-roller div:nth-child(4):after {
  top: 58px;
  left: 32px;
}
.lds-roller div:nth-child(5) {
  animation-delay: -0.18s;
}
.lds-roller div:nth-child(5):after {
  top: 57px;
  left: 25px;
}
.lds-roller div:nth-child(6) {
  animation-delay: -0.216s;
}
.lds-roller div:nth-child(6):after {
  top: 54px;
  left: 19px;
}
.lds-roller div:nth-child(7) {
  animation-delay: -0.252s;
}
.lds-roller div:nth-child(7):after {
  top: 50px;
  left: 14px;
}
.lds-roller div:nth-child(8) {
  animation-delay: -0.288s;
}
.lds-roller div:nth-child(8):after {
  top: 45px;
  left: 10px;
}
@keyframes lds-roller {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

}

@keyframes fadeIn {
    from {opacity: 0;}
    to {opacity: 1;;}
}
.title img{
  width: 100%;
}
.photo{
  width:150px;
}
.sign{
  width:150px;;
}
.green{
  color: rgb(7, 119, 44)
}

// instruction starts here
    .download-card {
        box-shadow: 12px 15px 20px 0 rgba(46, 61, 73, .15);
        background: #fff;
        padding: 21px;
        border-radius: 6px;
        margin-bottom: 10px;
        /* font-size: 13px;
        font-weight: 50; */
    }
    .download-card .mdi{
  font-size: 14px;
}
    .instruction-title{
      color: #333;
      font-size: 20px;
      color: #2e3d49;
    }
    .btn-circle {
        width: 30px;
        height: 30px;
        text-align: center;
        padding: 6px 0;
        font-size: 12px;
        line-height: 1.428571429;
        border-radius: 15px;
        background: #02b3e4;
        color: #fff;
        box-shadow: 5px 5px 25px 0 rgba(46, 61, 73, .2);
        margin-bottom: 10px;
        transition: all .2s ease-in;
    }
 .btn-circle.btn-xs {
        width: 30px;
        height: 30px;
        padding: 4px 7px;
        font-size: 18px;
        line-height: 1.33;
        border-radius: 20px;
    }
    .btn-circle.btn-lg {
        width: 50px;
        height: 50px;
        padding: 10px 16px;
        font-size: 18px;
        line-height: 1.33;
        border-radius: 25px;
    }

    .btn-circle.btn-xl {
        width: 70px;
        height: 70px;
        padding: 10px 16px;
        font-size: 24px;
        line-height: 1.33;
        border-radius: 35px;
    }
    .btn-circle:hover{
      background:#71d102;
        color: #fff;
       
    }
    .download-card .zmdi {
        font-size: 20px;
        
    }
  
    .instructions li{
  
    	list-style-type: none;

    font-size: 15px;
    text-indent: -1.28571429em;
    }
    .instructions li:before {
    font-family: Material Design Icons;
    content: "\f2c7";
  color: #000;
    position: relative;
    padding-right: 10px;
    top: -1px;
        list-style-position: inside;
}
.download-card .btn-text{
  font-size: 12px;
  font-weight: 700;
}
.video-card{
    box-shadow: 12px 15px 20px 0 rgba(46, 61, 73, .15);
        background: #fff;
        padding: 10px 25px;
        border-radius: 6px;
        margin-bottom: 30px;
}
.video-card p{
  margin-bottom: 0;
}
.video-card .dropzone{
  min-height:50px;
  padding:0;
}
.video-card .dropzone .dz-message {

    margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/workPlace/workPlace.vue